import { Alert, AlertTitle, IconButton, Slide } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useBanner } from "../hooks/useBanner";

/**
 * Component that displays a notification when a new version of the application is available.
 * Uses a subscription and fetch query to check the build version against the version from database.
 * 
 * @component
 * @example
 * return (
 *   <VersionUpdateNotification />
 * )
 * 
 * @description
 * - Subscribes and Query to version changes in the database
 * - Also check when newtwork is restored
 * - Compares current build version with database version
 * - Shows notification if newer version is available
 * - Provides reload button to update to new version
 * - Auto-hides after user reloads the page
 * 
 * @see useVersionChecker - Custom hook that handles version checking logic
 */
const VersionUpdateNotification = () => {

    const { isVisible, handleClose, handleReload, version } = useBanner()

    if (!isVisible) {
        return null;
    }

    return (
        <Slide direction="down" in={isVisible} mountOnEnter unmountOnExit>
            <Alert
                severity="success"
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    right: 0,
                    zIndex: 9999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center', // Added to center vertically
                    gap: '10px',
                    margin: 0,
                    borderRadius: 0,
                    width: 'auto',
                    border: '1px solid'
                }}
                action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={handleClose}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                }
            >
                <AlertTitle
                    onClick={handleReload}
                    sx={{
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center', // Added to center text vertically,
                        margin: '0px'
                    }}
                >
                    New version {version} is available - tap to reload
                </AlertTitle>
            </Alert>
        </Slide>
    );
};

export { VersionUpdateNotification }
